import { render, staticRenderFns } from "./FundTransferInternalCard.vue?vue&type=template&id=fd77dfd6&scoped=true&"
import script from "./FundTransferInternalCard.vue?vue&type=script&lang=js&"
export * from "./FundTransferInternalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd77dfd6",
  null
  
)

export default component.exports